import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { CancelReasonsService } from 'src/app/services/core/cancelReason/cancel-reasons.service';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { ConfigurationService } from 'src/app/services/core/configuration/configuration.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()

@Component({
  selector: 'app-multi-cancel-modal',
  templateUrl: './multi-cancel-modal.component.html',
  styleUrls: ['./multi-cancel-modal.component.css']
})
export class MultiCancelModalComponent implements OnInit {
  @Input() trips: any = [];
  @Input() preServiceAreas: any;
  companies: any = [];
  preAppointmentType: any;
  preSpacetypes: any;
  preMembers: any;
  selectedCompany: any = null;
  selectedTrips: any;
  preCompanies: any = {}
  @Output() closeModal = new EventEmitter<any>();
  status: any;
  cancelReason: any;
  cancelReasons: any = [];
  preLevelOfService: any;
  search: any;
  previousAssignedCompanies: any;
   allCancelReasons:any
  noshowReasons:any
  billAbleReasons:any;
   isBillable:boolean = false;
  isNoShow: boolean = false;
  @Output() cancelTripData = new EventEmitter<any>();

  constructor(
    private tripService: TripService,
    private companyService: CompanyService,
    private appointmentService: AppointmentTypeService,
    private spaceTypeService: SpaceTypeService,
    private memberService: MemberService,
    private cancelReasonService: CancelReasonsService,
    private router: Router,
    private levelOfService: LosService,
    private credentialService: CredentialService
    
  ) {}

  ngOnInit(): void {
    this.status = this.trips && this.trips.length ? this.trips[0].status : '';
    this.selectedTrips = this.trips.map((trip: any) => {
      return trip.id
    })
    this.previousAssignedCompanies = this.trips.map((trip: any) => {
      return { company: trip.company, trip: trip.id }
    });
    this.getPicker()
    this.getAllAppointment();
    // this.getAllMembers();
    this.getSpaceType();
    this.getAllCompanies();
  }

  getAllCompanies() {
    this.credentialService.getPicker({ isActive: true, limit:9999 }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results && data.results.length) {
        this.preCompanies = data.results.reduce((obj: any, item: any) => ((obj[item.id] = item), obj), {});
      }
    });
  }

  getAllAppointment() {
    this.appointmentService.getPicker({ isActive: true, limit:9999 }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data.results && data.results.length) {
        this.preAppointmentType = data.results.reduce((obj: any, item: any) => ((obj[item.id] = item), obj), {});
      }
    });
  }

  getSpaceType() {
    this.spaceTypeService.getPicker({ isActive: true, limit:9999 }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results && data.results.length) {
        this.preSpacetypes = data.results.reduce((obj: any, item: any) => ((obj[item.id] = item), obj), {});
      }
    });
  }

  getLevelOfService() {
    this.levelOfService.getPicker({ isActive: true, limit:9999 }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results && data.results.length) {
        this.preLevelOfService = data.results.reduce((obj: any, item: any) => ((obj[item.id] = item), obj), {});
      }
    });
  }

  getAllMembers() {
    this.memberService.getPickerMembers({ isActive: true, limit:9999 }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results && data.results.length) {
        this.preMembers = data.results.reduce((obj: any, item: any) => ((obj[item.id] = item), obj), {});
      }
    });
  }
  getPicker() {
    const param = {
      limit: 999,
      isActive:true
    }
  this.cancelReasonService.picker(param)
    .pipe(untilDestroyed(this))
    .subscribe((data: any) => {
      if (data && data.results) {

        this.allCancelReasons = data.results;
        
        this.cancelReasons = data.results.filter((r: any) =>
          r.isBillable === false && r.isNoShow === false
        );
        
        // this.billAbleReasons = data.results.filter((r: any) =>
        //   r.isActive === true &&
        //   r.isBillable === true && r.isNoShow === false
        // );

        // this.noshowReasons = data.results.filter((r: any) =>
        //   r.isActive === true &&
        //   r.isNoShow === true
        // );
      }
    });
}


  onCloseModal() {
    this.closeModal.emit();
  }

  cancel() {
    const payload = {
      pre: this.previousAssignedCompanies,
      selectedIds: this.selectedTrips,
      changeReasonNotes: this.cancelReason,
      status: "cancelled",
      isBillable : this.isBillable,
      isNoShow: this.isNoShow
    };
    this.apiRequest(payload);
  }

  apiRequest(payload: any) {
    this.tripService.assignToCompany(payload).pipe(untilDestroyed(this)).subscribe({
      next: (res) => {
        if (res) {
          this.cancelTripData.emit(this.selectedTrips,)
          this.onCloseModal();
        }
      }
    })
  }
   setReason(selectedReason: string) {
    const reasonObj =  this.allCancelReasons.find((r:any) => r.title === selectedReason);
  if (reasonObj) {
    this.cancelReason = reasonObj.title;
    this.isBillable = !!reasonObj.isBillable;
    this.isNoShow = !!reasonObj.isNoShow;
  } else {
    this.cancelReason = '';
    this.isBillable = false;
    this.isNoShow = false;
  }
}
}

